module.exports = __webpack_public_path__ + "static/rappi-logo-1de59701baf07b77cdbef006e874ad3f.png";